import { render, staticRenderFns } from "./SistemaPermissaoEdit.vue?vue&type=template&id=64d590b3"
import script from "./SistemaPermissaoEdit.vue?vue&type=script&lang=js"
export * from "./SistemaPermissaoEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports